import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const PaiementRevolut = (props) => {

  return (
    <Modal show={props.cotisation} onHide={() => props.setChangement()}>
      <Modal.Header closeButton>
        <Modal.Title>Paiement Revolut</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formMontant">
            <Form.Label>Montant à payer</Form.Label>
            <Form.Control 
              type="number" 
              value={props.cotisation.cotisationJoueur[0].prixCotisation} 
              disabled 
              placeholder="Montant en euros" 
            />
          </Form.Group>
        </Form>
        <div className="mt-3">
          <Button 
            href={props.cotisation.cotisationJoueur[0].lienRevolut}  
            target="_blank" 
            style={{ backgroundColor: "#00E676", borderColor: '#00E676', width: '100%' }}
          >
            Payer avec Revolut
          </Button>
        </div>
        <div className="mt-3">
          <h5>Comment effectuer le paiement :</h5>
          <ol>
            <li>Cliquez sur le bouton "Payer avec Revolut".</li>
            <li>Entrez le montant affiché dans la case Montant à payer.</li>
            <li>Suivez les instructions Revolut pour compléter le paiement.</li>
            <li>Dès que vous avez réglé le paiement, vous pouvez revenir sur cette page pour confirmer la transaction.</li>
          </ol>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => props.setChangement()}>
          Annuler
        </Button>
        <Button 
          variant="primary" 
          onClick={(e) => props.handleSubmit(e)} 
          style={{ backgroundColor: "#00E676", borderColor: '#00E676' }}
        >
          Confirmer le paiement
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PaiementRevolut;
